import apiClient from "../apiClient";

const resource = "employees";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    add: payload => apiClient.post(`${resource}`, payload),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    getForEmploymentStatement: id => apiClient.get(`${resource}/${id}/employmentStatement`),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    lock: (id,payload) => apiClient.put(`${resource}/${id}/lock`,payload,{ 'Content-Type': 'multipart/form-data' }),
    unlock: (id,payload) => apiClient.put(`${resource}/${id}/unlock`,payload,{ 'Content-Type': 'multipart/form-data' }),

    delete: id => apiClient.delete(`${resource}/${id}`),
    employeeReturn: id => apiClient.put(`${resource}/${id}/return`),
    complete: (id, payload) => apiClient.put(`${resource}/${id}/complete`, payload),
    getImages: id => apiClient.get(`${resource}/${id}/Images`),
    checkName: (params) => apiClient.get(`${resource}/checkName?${params}`),

    uploadImage: (payload) => apiClient.put(`${resource}/uploadImage`, payload),
    uploadMultiImage: (id,payload) => apiClient.put(`${resource}/${id}/uploadmMultiImage`, payload),
    getAttachmentsArchives: (id,params) => apiClient.get(`${resource}/${id}/attachmentsArchives?${params}`),
};